import { ButtonKind } from "@livechat/design-system";

import { isBooleanOrUndefined } from "helpers/boolean";

import { ComponentTypeEnum } from "./component-types";

export interface IButtonData {
  label: string;
  id: string;
  openApp?: boolean;
  buttonType?: ButtonKind;
}

export interface IButtonComponentDefinition {
  type: ComponentTypeEnum.Button;
  data: IButtonData;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValidButtonDefinition(rawDefinitionData: any): boolean {
  if (!rawDefinitionData) {
    return false;
  }
  const { label, id, openApp } = rawDefinitionData;
  return Boolean(label && id && isBooleanOrUndefined(openApp));
}
